import { createDateRangeFilterConfig } from '../factories/create-date-range-filter-config';
import { buildDateRangeFacetKey } from '../helpers/build-date-range-facet-key';
import { FILTER_COLOR } from './filter-colors';

export const enrolledDateFilterConfig = createDateRangeFilterConfig({
  facetName: buildDateRangeFacetKey({
    before: 'enrolled_date_before',
    after: 'enrolled_date_after',
  }),
  color: FILTER_COLOR.green,
});
